import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { solarizedlight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import remarkGfm from 'remark-gfm';
import './Messages.css';
import ChatMessageFeedbackButtons from './ChatMessageFeedbackButtons';
import { File } from 'lucide-react';

const Message = ({ id, chatId, content, sender, file_name }) => {
  const renderContent = () => {
    if (typeof content === 'string') {
      return (
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}  // Adding this line to enable tables
          components={{
            code({ node, inline, className, children, ...props }) {
              const match = /language-(\w+)/.exec(className || '');
              return !inline && match ? (
                <SyntaxHighlighter
                  style={solarizedlight}
                  language={match[1]}
                  PreTag="div"
                  {...props}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            },
            table({ node, ...props }) {
              return (
                <div className="table-container">
                  <table {...props} className="message-table" />
                </div>
              );
            },
            th({ node, ...props }) {
              return <th {...props} className="message-th" />;
            },
            td({ node, ...props }) {
              return <td {...props} className="message-td" />;
            },
            img({ node, ...props }) {
              return <img className="message-image" {...props} alt={props.alt || ''} />;
            },
            a({ node, children, ...props }) {
              return <a target="_blank" className="message-link" rel="noopener noreferrer" {...props}>{children}</a>;
            }
          }}
        >
          {content}
        </ReactMarkdown>
      );
    } else if (typeof content === 'object') {
      // Handle other types of content (e.g., JSON objects) here
      return <pre>{JSON.stringify(content, null, 2)}</pre>;
    }
    return content;
  };

  return (
    <div className={`message ${sender}`}>
      <div className ="flex flex-col items-start w-full max-w-full">
        {sender === "user" && file_name && (
          <div className="mb-3 bg-gray-100 text-gray-700 px-3 py-2 rounded-lg shadow max-w-full border border-solid border-b-orange-200 border-r-orange-200">
            <p className="flex items-center gap-2">
              <File size={24} className="text-lime-700" />
              <span className="truncate text-sm font-semibold text-stone-700">{file_name}</span>
            </p>
          </div>
        )}

        <div className="message-content">{renderContent()}</div>
      </div>

      {sender === "assistant" && (
        <ChatMessageFeedbackButtons messageId={id} chatId={chatId} />
      )}
    </div>
  );
};

export default Message;
